import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["track", "dot"];
  TIME_PER_SLIDE_IN_SECONDS = 10;
  currentIndex = 0;

  connect () {
    this.resetTimer();
  }

  disconnect () {
    clearInterval(this.timer);
  }

  prev () {
    this.goToSlide((this.currentIndex - 1 + this.slideCount()) % this.slideCount());
  }

  next () {
    this.goToSlide((this.currentIndex + 1) % this.slideCount());
  }

  goTo (event) {
    this.goToSlide(event.params.index);
  }

  goToSlide (index) {
    this.currentIndex = index;
    this.trackTarget.style.transform = `translateX(-${index * 100}%)`;
    this.dotTargets.forEach((dot, i) => dot.classList.toggle("active", i === index));
    this.resetTimer();
  }

  resetTimer () {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.next(), this.TIME_PER_SLIDE_IN_SECONDS * 1000);
  }

  slideCount () {
    return this.dotTargets.length;
  }
}
